import { Component, inject, Injector } from '@angular/core';
import { ChoosePasswordRequest } from '../../../../../../models/users/requests/choose-password-request';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { InternalUserAuthViewModel } from '../../../../viewModels/internal-user-auth-view-model.service';
import { SessionService } from '../../../../../../services/session-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PasswordInputUtils } from '../../../../../../utils/password-input-utils';
import { createChoosePasswordFormGroup } from '../../../../forms/choose-password-form-group';

@Component({
  selector: 'app-internal-user-choose-password',
  templateUrl: './internal-user-choose-password.component.html',
  styleUrls: ['./internal-user-choose-password.component.scss', '../../auth.component.scss']
})
export class InternalUserChoosePasswordComponent extends BaseComponent {
  ngbModal = inject(NgbModal);
  injector = inject(Injector);
  viewModel = inject(InternalUserAuthViewModel);

  protected readonly passwordHintText = PasswordInputUtils.passwordHintText;

  public formGroup = createChoosePasswordFormGroup({ emailDisabled: true });
  public formSubmitted = false;

  public customErrorMessages = {
    password: {
      passwordMinLength: $localize`Password must be at least 8 characters`,
      passwordMaxLength: $localize`Password cannot exceed 50 characters`
    },
    eula: {
      required: $localize`Terms and Conditions must be accepted in order to continue.`
    }
  };

  private challengeName = '';
  private sessionId = '';

  constructor(private session: SessionService) {
    super();
  }

  setupBindings(): void {}

  // Prefill runs in setupViews (ngOnInit) so synchronous emissions patch the form before the first change detection pass
  setupViews() {
    this.session.sessionContainer$.once(session => {
      if (!session) session = this.viewModel.getCachedSession();
      const user = session?.user;
      this.formGroup.controls.email.patchValue(user?.email ?? '');
      this.sessionId = user?.sessionId ?? '';
      this.challengeName = user?.challengeName ?? '';
    });
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const { email, password, confirmPassword, eulaAccepted } = this.formGroup.getRawValue();
    const req = new ChoosePasswordRequest(
      email,
      password,
      confirmPassword,
      this.challengeName,
      this.sessionId,
      eulaAccepted
    );
    this.viewModel.setNewInternalUserPassword(req);
  }

  openEulaModal(): void {
    this.formGroup.controls.eulaAccepted.patchValue(false);
    this.viewModel.openEulaModal();
  }
}
